import { useEffect } from "react";
import { isLocalParticipantCanShareScreen } from "../../../sharescreen-moderation/functions";
import { useDispatch, useSelector } from "react-redux";
import { isScreenVideoShared } from "../../../screen-share/functions";
import { toggleScreensharing } from "../../../base/tracks/actions.web";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../../notifications";
import { useTranslation } from "react-i18next";
import React from 'react';
import { getLocalParticipant, hasRaisedHand } from "../../../base/participants/functions";
import { isLocalParticipantCanRaisehand } from "../../../raisehand-moderation/functions";
import { raiseHand } from "../../../base/participants/actions";
import { isLocalParticipantCanChangeName } from "../../../changename-moderation/functions";
export default function ModerationHandler() {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const localParticipant = getLocalParticipant(state);
    const canShareScreen = isLocalParticipantCanShareScreen(state);
    const isScreenSharing = isScreenVideoShared(state);
    const isRaisingHand = hasRaisedHand(localParticipant);
    const canRaisehand = isLocalParticipantCanRaisehand(state);
    const canChangeName = isLocalParticipantCanChangeName(state);
    useEffect(() => {
        if (!canShareScreen && isScreenSharing) {
            dispatch(toggleScreensharing(false));
            if (isScreenSharing) {
                dispatch(showNotification({
                    titleKey: t("notify.hostBan", { action: t("notify.action.shareScreen") }),
                }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }
        }
    }, [canShareScreen, isScreenSharing]);
    useEffect(() => {
        if (isRaisingHand && !canRaisehand) {
            dispatch(raiseHand(false));
        }
    }, [isRaisingHand, canRaisehand]);
    // useEffect(() => {
    //   if (!canChangeName) {
    //     APP?.conference?.changeLocalDisplayName(JSON.parse(window.localStorage.getItem("user"))?.username);
    //   }
    // }, [canChangeName])
    return (React.createElement("div", null));
}
